<script context="module">
    export const name = "large default";

    export const CustomFields = z.object({
        show_summary: z.boolean().default(false),
    });
</script>

<script lang="ts">
    import Data from "@reperio-news/core.components/blocks/ContentItem/Data";
    import { stripTags } from "@reperio-news/core.components/includes/Helpers";
    import { z } from "zod";
    type Data = z.infer<typeof Data>;
    import { getContext } from "svelte";
    import ImageView from "@reperio-news/core.components/ImageView.svelte";

    export let data: Data = {};
    const context: SvelteStore<any> = getContext("context");
</script>

{#if data && data.content}
    <div
        class="entry"
        style="--bgColor: {$context.domain_config.MISC.boxColorLight}"
    >
        {#if data.content.poster}
            <a
                class="image"
                href={data.content.url}
                title={data.content.summary}
            >
                <ImageView
                    src={data.content.poster}
                    crop={data.content.poster.crop}
                    width={1000}
                    height={400}
                    widths={[1000, 600]}
                    heights={[400, 240]}
                    animatedQuality={45}
                    fit="cover"
                />
            </a>
        {/if}

        <div class="mainInfo">
            <div class="of">
                {#if data.content.topic}
                    <a
                        class="topic"
                        href="//{data.content.domain}/{data.content.topic.slug}"
                        title="Ultimele știri - {data.content.topic.name}"
                    >
                        #{data.content.topic.name}
                    </a>
                {/if}
            </div>

            <a
                class="title"
                href={data.content.url}
                title={stripTags(data.content.summary)}
                >{@html stripTags(data.content.title, ["i", "b", "strong", "font"])}</a
            >

            {#if data.custom_fields && data.custom_fields.show_summary && data.content.summary}
                <div class="summary">
                    {@html stripTags(data.content.summary, ["i", "b", "strong", "font"])}
                </div>
            {/if}
        </div>
    </div>
{/if}

<style lang="scss">
    :global(.blockContainer-width-full) {
        .entry {
            margin: 10px auto 10px auto;
        }
    }

    .entry {
        box-shadow: -1px 3px 3px -4px #821818;
        display: block;
        min-width: 300px;
        flex-grow: 1;
        color: inherit;
        margin: 10px;
        border: 1px solid #f1f1f1;
        background-color: var(--bgColor);
        color: #111;
        max-width: 1180px;
        position: relative;

        .image {
            min-width: 250px;
            /* box ratio matches the 1000x400 request — proportional
               instead of a hidden second crop when the card is narrower */
            aspect-ratio: 5 / 2;
            height: auto;
            overflow: hidden;
            display: block;
        }

        .mainInfo {
            text-align: left;
            display: flex;
            justify-content: center;
            align-content: center;
            align-items: center;
            // height: 85px;
            padding: 15px 4px;
            text-align: center;
            position: relative;
            flex-wrap: wrap;

            .of {
                position: absolute;
                top: -10px;
                left: 5px;
                width: 100%;
                display: flex;
                justify-content: center;
            }

            .title {
                font-style: normal;
                font-weight: 900;
                color: #000;
                font-size: 30px;
                letter-spacing: 0.5px;
                text-align: left;
                width: calc(100% - 10px);

                overflow: hidden;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                text-overflow: hidden;
                white-space: normal;
                text-overflow: ellipsis;
            }

            .summary {
                overflow: hidden;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                text-overflow: hidden;
                white-space: normal;
                text-overflow: ellipsis;
                width: calc(100% - 10px);
                margin: auto;
                padding: 5px;
                text-align: left;
                font-size: 21px;
                font-weight: 300;
                -webkit-line-clamp: 2;
            }
        }

        .topic {
            background-color: rgb(187, 0, 0);
            color: #fff;
            text-align: center;
            padding: 0 2px 0 2px;
            display: inline-block;
            padding: 2px;
            text-transform: uppercase;
        }
    }

    @media only screen and (max-width: 650px) {
        .entry {
            .image {
                height: auto;
            }
        }

        .co-1 {
            width: calc(100% - 30px);
        }
    }

    @media only screen and (max-width: 500px) {
        .entry {
            border-bottom: 4px solid #f1f1f1;
        }
    }
</style>
